import * as Scrivito from "scrivito";

export default function configureScrivitoContentBrowser() {
  Scrivito.configureContentBrowser({
    filters: ({ _validObjClasses }) => {
      if (_validObjClasses) {
        switch (_validObjClasses.length) {
          case 0:
            return defaultFilters();
          case 1:
            return filterForObjClass(_validObjClasses[0]);
          default:
            return filtersForObjClasses(_validObjClasses);
        }
      }

      return defaultFilters();
    },
  });
}

function filterForObjClass(objClass) {
  return {
    _objClass: {
      options: {
        [objClass]: {
          ...filterOptionsForObjClass(objClass),
          selected: true,
        },
      },
    },
  };
}

function filtersForObjClasses(objClasses) {
  return {
    _objClass: {
      options: {
        All: {
          title: "All",
          icon: "folder",
          field: "_objClass",
          value: objClasses,
          selected: true,
        },
        ...objClasses.reduce((result, value) => {
          result[value] = filterOptionsForObjClass(value);
          return result;
        }, {}),
      },
    },
  };
}

function defaultFilters() {
  return {
    _objClass: {
      options: {
        All: {
          title: "All",
          icon: "folder",
          query: Scrivito.Obj.all(),
          selected: true,
        },
        Assets: {
          title: "Assets",
          icon: "image",
          field: "_objClass",
          value: ASSETS,
          options: ASSETS.reduce((result, value) => {
            result[value] = filterOptionsForObjClass(value);
            return result;
          }, {}),
        },
        Pages: {
          title: "Pages",
          icon: "sheet",
          field: "_objClass",
          value: PAGES,
          options: PAGES.reduce((result, value) => {
            result[value] = filterOptionsForObjClass(value);
            return result;
          }, {}),
        },
        SpecialPages: {
          title: "Special pages",
          icon: "wand",
          field: "_objClass",
          value: SPECIAL_PAGES,
          options: SPECIAL_PAGES.reduce((result, value) => {
            result[value] = filterOptionsForObjClass(value);
            return result;
          }, {}),
        },
        InvalidPages: {
          title: "Invalid pages",
          icon: "time",
          options: {
            EventPage: {
              title: "expired Events",
              query: Scrivito.Obj.onAllSites()
                .where("_objClass", "equals", "EventPage")
                .andNot("endDate", "equals", "")
                .and("endDate", "isLessThan", new Date()),
            },
            NewsPage: {
              title: "locked News",
              query: Scrivito.Obj.onAllSites()
                .where("_objClass", "equals", "NewsPage")
                .andNot("publishUntilDate", "equals", "")
                .and("publishUntilDate", "isLessThan", new Date()),
            },
          },
        },
      },
    },
    _siteId: {
      title: "Site",
      type: "checkbox",
      expanded: false,
      field: "_siteId",
      options: {
        De: { value: "de" },
        En: { value: "en" },
        Intranet: { value: "intranet" },
      },
    },
    _modification: {
      title: "Changed",
      type: "checkbox",
      expanded: false,
      field: "_modification",
      options: {
        New: {
          value: "new",
        },
        Edited: {
          value: "edited",
        },
      },
    },
  };
}

function filterOptionsForObjClass(objClass) {
  const filterPresentation = FILTER_PRESENTATIONS[objClass] || {
    title: objClass,
    icon: "question",
  };
  return { field: "_objClass", value: objClass, ...filterPresentation };
}

const FILTER_PRESENTATIONS = {
  Page: { title: "Pages", icon: "sheet" },
  Author: { title: "Authors", icon: "user" },
  Download: { title: "Downloads", icon: "pdf" },
  Image: { title: "Images", icon: "image" },
  Video: { title: "Videos", icon: "video" },
  CoursePage: { title: "Courses", icon: "certificate" },
  Quote: { title: "Quotes", icon: "chat" },
  ContactPage: { title: "Contacts", icon: "users" },
  EventPage: { title: "Events", icon: "cal" },
  NewsPage: { title: "News", icon: "sheet" },
  Homepage: { title: "Homepage", icon: "globe" },
  SearchResults: { title: "Search results", icon: "lens" },
  EventOverviewPage: { title: "Event overview page", icon: "list" },
  NewsOverviewPage: { title: "News overview page", icon: "list" },
  LoginRedirectPage: { title: "Login Redirect", icon: "relation" },
  Redirect: { title: "Redirect", icon: "relation" },
};

const PAGES = ["Page", "CoursePage", "ContactPage", "EventPage", "NewsPage"];

const ASSETS = ["Image", "Download", "Video"];

const SPECIAL_PAGES = [
  "Homepage",
  "SearchResults",
  "EventOverviewPage",
  "NewsOverviewPage",
  "LoginRedirectPage",
  "Redirect",
  "Quote",
];
